import React, { useEffect } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import { Footer } from "../components/Footer";
import Nav from "../components/Navbar/Nav";

export const AuthLayout = () => {
  const navigate = useNavigate();
  useEffect(() => {
    if (localStorage.getItem("token")) {
      navigate("/auth/physioscope");
    }
  }, []);
  return (
    <>
      <Nav />
      <main className="overflow-hidden w-full mt-16 md:mt-16">
      <Outlet />
      </main>
      <Footer />
    </>
  );
};

